import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ThreeDModel from "./3DModel/ThreeDModel";
import NavBar from "./common/NavBar";
import Footer from "./common/Footer";
import DigitalTwin from "./DigitalTwin/DigitalTwin";
import KrpanoPlayer from "./DigitalTwin/KrpanoPlayer";
import VRDevelopment from "./VRDevelopment/VRDevelopment";

import ThreeDModelJP from "./JP/3DModel/ThreeDModelJP";
import VRDevelopmentJP from "./JP/VRDevelopment/VRDevelopmentJP";
import DigitalTwinJP from "./JP/DigitalTwin/DigitalTwinJP";
import KrpanoPlayerJP from "./JP/DigitalTwin/KrpanoPlayerJP";

const App = () => {
	return (
		<>
		<Router>
			<NavBar />
			<Routes>
				{/* Start of Defult English version */}
				<Route path="/three-D-model" element={<ThreeDModel />}> </Route>
				<Route path="/digital-twins" element={<DigitalTwin />}> </Route>
				<Route path="/vr-development" element={<VRDevelopment />}> </Route>
				<Route path="/krpano-player" element={<KrpanoPlayer />}> </Route>
				<Route path="/" element={<ThreeDModel />}> </Route>
				{/* End of English version */}

				{/* Start of Jananese Version */}
				<Route path="/jp/three-D-model" element={<ThreeDModelJP />}> </Route>
				<Route path="/jp/digital-twins" element={<DigitalTwinJP />}> </Route>
				<Route path="/jp/vr-development" element={<VRDevelopmentJP />}> </Route>
				<Route path="/jp/krpano-player" element={<KrpanoPlayerJP />}> </Route>
				<Route path="/jp/" element={<ThreeDModelJP />}> </Route>
				{/* End of Japansese Version */}
			</Routes>
			<Footer />
		</Router>
		</>
	);
}

export default App;
